export { default } from "./DefinitionTooltip";
export type { DefinitionTooltipInfo } from "./DefinitionTooltip";
